<template>
  <div>
    <Header></Header>

    <!-- PAGE HEADER -->
    <div class="page-header quem-somos">
      <div class="container">
        <div class="row">
          <div class="col-md-offset-1 col-md-10 text-center">
            <h1 class="text-uppercase">Sobre Nós</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- /PAGE HEADER -->

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-12">
            <div class="section-row">
              <div class="section-title">
                <h2 class="title">PEDLINE</h2>
              </div>
              <p>O Pedline é um portal de informações sobre a saúde de crianças e adolescentes. Sem fins lucrativos, este é um trabalho de empreendedorismo solidário, desenvolvido com o apoio de profissionais de saúde voluntários, com o objetivo de ser uma ferramenta para a prevenção e para ajudar no diagnóstico precoce de doenças para essa faixa etária, já que muitos tratamentos clínicos e cirúrgicos realizados na idade correta têm mais chance de cura, além de diminuir os riscos de sequelas.</p>
              <p>Todo nosso conteúdo é revisado pelos Departamentos de Pediatria e de Cirurgia Pediátrica da SMCC (Sociedade de Medicina e Cirurgia de Campinas) e pela Odontopediatria ACDC (Associação dos Cirurgiões Dentistas de Campinas).</p>
              <p>Desenvolvemos um trabalho sério, com respaldo científico, para que pais, mães e outras pessoas que lidam diariamente com crianças e adolescentes possam ter acesso a conteúdo de qualidade, mas sempre lembrando que nenhuma informação substitui a consulta presencial com um profissional de saúde de sua confiança.</p>
              <br />
              <p
                style="font-style:italic;"
              >Os artigos assinados são de responsabilidade de seus autores.</p>
            </div>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "QuemSomos",
  components: {
    Header,
    Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/QuemSomos.vue